import styled from '@emotion/styled';

import Tag from '../Tag';

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${Tag} {
    margin-right: var(--gutter-little);
    margin-top: var(--gutter-little);
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    font-size: var(--font-size-tiny);
  }
`;

export const StyledTagsGroup = styled.div`
  margin-bottom: var(--gutter-little);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  color: var(--color-core-primary);
`;
